import React, { useState } from "react";
import styled from "@emotion/styled";

export const StyledButton = styled("button")(
  ({ backgroundColor, color, border, width, hoverStyles, hoverd }) => ({
    background: backgroundColor ? `${backgroundColor}` : "#6860ee",
    color: color || "white",
    padding: "8px 14px",
    border: border || "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    outline: "none",
    display: "flex",
    alignItems: "center",
    width: width,
    textAlign: "center",
    justifyContent: "center",
    gap: "10px",
    ...(hoverd && {
      "&:hover": {
        ...hoverStyles,
      },
    }),
  })
);

export const StyledFileCountContainer = styled("span")(
  ({ fileCountbackgroundColor, fileCountColor }) => ({
    background: fileCountbackgroundColor
      ? fileCountbackgroundColor
      : "#6860ee",
    color: fileCountColor ? fileCountColor : "white",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "bold",
  })
);

export const ExportButton = styled(StyledButton)({
  backgroundColor: "#EEF8F1",
  color: "#216E3A",
  border: "1px solid #216E3A",
});

export const CancelButton = styled(StyledButton)({
  background: "none",
  border: "1px solid #6860EE",
  color: "#6860EE",
  marginRight: "25px",
});

export const StyledIcon = styled("img")(({ iconWidth }) => ({
  width: iconWidth,
}));

const customHoverStyles = {
  backgroundColor: "#5c47ce",
  color: "#FFFFFF",
  transform: "scale(1.05)",
  transition: "all 0.3s ease",
};

function Button(props) {
  const {
    event = () => "",
    onMouseDown,
    ariaLabel = "",
    type = "button",
    label = "",
    className = "",
    key = "",
    loading = false,
    customLoading = false,
    disabled = false,
    isCancel = false,
    style = {},
    icon = null,
    iconSrc = null,
    hoverIconSrc = null, 
    isExport = false,
    backgroundColor = "",
    color = "",
    border = "",
    width = "",
    iconWidth = "25px",
    iconPosition = "left",
    fileCount = 0,
    fileCountColor = "",
    fileCountbackgroundColor = "",
    hoverStyles = {},
    hoverd= true,
    shine = false,
    glitter = false,
    aiSparkle = false,
    wave = false,
    glow = false,
    superShine = false,
  } = props || {};

  const [isHovered, setIsHovered] = useState(false);

  const ButtonComponent = isExport
    ? ExportButton
    : isCancel
    ? CancelButton
    : StyledButton;

  const currentIconSrc = isHovered && hoverIconSrc ? hoverIconSrc : iconSrc;
  
  const animationClasses = [
    className,
    shine ? "shine-button" : "",
    glitter ? "glitter-effect" : "",
    aiSparkle ? "ai-sparkle-button" : "",
    wave ? "wave-shine" : "",
    glow ? "glow-pulse" : "",
    superShine ? "super-shine-button" : "",
  ].filter(Boolean).join(" ");
  const appliedHoverStyles = Object.keys(hoverStyles).length > 0 ? hoverStyles : customHoverStyles;
  return (
    <ButtonComponent
      onClick={event}
      onMouseDown={onMouseDown}
      aria-label={ariaLabel || undefined}
      aria-pressed={props["aria-pressed"]}
      key={key}
      type={type}
      className={animationClasses}
      style={{
        ...style,
        cursor: disabled || loading || customLoading ? "not-allowed" : "pointer",
      }}
      disabled={disabled || loading || customLoading}
      backgroundColor={backgroundColor}
      color={color}
      border={border}
      width={width}
      fileCountColor={fileCountColor}
      fileCountbackgroundColor={fileCountbackgroundColor}
      hoverStyles={appliedHoverStyles}
      hoverd={hoverd}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {iconPosition === "left" && currentIconSrc && (
        <StyledIcon src={currentIconSrc} width={iconWidth} alt="icon" />
      )}
      {props.children}
      {label && <span>{label}</span>}
      
      {fileCount > 0 && (
        <StyledFileCountContainer
          fileCountColor={fileCountColor}
          fileCountbackgroundColor={fileCountbackgroundColor}
        >
          {fileCount}
        </StyledFileCountContainer>
      )}
      {iconPosition === "right" && currentIconSrc && (
        <StyledIcon src={currentIconSrc} width={iconWidth} alt="icon" />
      )}
      {icon}
    </ButtonComponent>
  );
}

export default Button;
